import { render, staticRenderFns } from "./print-positions-manager-v2.vue?vue&type=template&id=56a1bc06&shadow"
import script from "./print-positions-manager-v2.vue?vue&type=script&lang=ts&shadow"
export * from "./print-positions-manager-v2.vue?vue&type=script&lang=ts&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports